<template>
  <div class="ecm__useraddress">
    <el-dialog
      title="Your address"
      :visible.sync="isShow"
    >
      <button @click="handleShowCreateAddress" class="ecm__useraddress-create">Create New Address</button>
      <div class="ecm__useraddress__list">
        <AddressCard
          v-for="(address) in addresses" :key="address.id"
          :address="address"
          @handleSetMainAddress="handleSetMainAddress"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddressCard from '@/components/AddressCard'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'User_Address',
  components: {
    AddressCard
  },
  data () {
    return {
      dialogVisible: true,
      isShow: false
    }
  },
  computed: {
    ...mapState({
      addresses: state => state.address.addresses
    })
  },
  methods: {
    ...mapActions({
      updateIsMainAddress: 'address/updateIsMainAddress'
    }),
    setIsShow (payload) {
      this.$data.isShow = payload
    },
    handleSetMainAddress ({ addressId }) {
      this.updateIsMainAddress({ addressId })
        .then(resp => {
          this.$emit('handleFetchShipmentsAddress')
          this.setIsShow(false)
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleCheckCostCourier (courierName, costId, cost, etd, code) {
      this.$emit('handleCourierCost', {
        courierName,
        costId,
        cost,
        etd,
        code
      })
      this.setIsShow(false)
    },
    handleShowCreateAddress () {
      setTimeout(() => {
        this.$root.$emit('showCreateAddress', true)
      }, 300)
      this.setIsShow(false)
    },
    handleClose (done) {
      this.$confirm('Are you sure to close this dialog?')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__useraddress {
  position: absolute;
  &::v-deep .el-dialog__wrapper {
    .el-dialog {
      padding: 20px;
      width: 750px;
      .el-dialog__header {
        padding: 0;
        .el-dialog__title {
          font-weight: 500;
          font-size: 20px;
          color: var(--color-blue-background);
        }
      }
      .el-dialog__body {
        padding: 20px 0 0 0;
        .ecm__useraddress-create {
          border: none;
          outline: none;
          width: 100%;
          padding: 5px;
          font-size: 17px;
          font-weight: 600;
          border-radius: 3px;
          background: var(--color-blue);
          color: white;
          cursor: pointer;
          margin-bottom: 10px;
        }
      }
      .el-dialog__footer {
        display: none;
      }
    }
  }
}
</style>
